{
  "title": "Accès",
  "subtitlePlatform": "Tous ceux qui se sont connectés au portail. Une personne qui se connecte sans invitation apparaît ici sans rôle et reste sur l’écran d’attente d’accès jusqu’à ce qu’on lui en accorde un.",
  "subtitleTenant": "Personnes qui peuvent accéder à ce locataire. Invitez quelqu’un qui ne s’est pas encore connecté, ou accordez l’accès à quelqu’un qui l’a déjà fait.",
  "partnerTitle": "Équipe partenaire",
  "partnerSubtitle": "Personnes qui peuvent administrer ce portefeuille partenaire — inviter des clients, gérer les signatures et inviter d’autres administrateurs partenaires.",
  "partnerInviteHint": "Ils deviennent administrateurs partenaires de ce portefeuille. La connexion suffit — le rôle s’applique à leur première visite.",
  "nobodyYetPartner": "Pas encore d’administrateurs partenaires hors invitations en attente. Invitez un collègue avec l’adresse qu’il utilisera pour se connecter.",
  "inviteSomebody": "Inviter quelqu’un",
  "grantAccess": "Accorder l’accès",
  "waitingTitle": "En attente d’acceptation",
  "waitingHint": "Le rôle s’applique automatiquement à leur première connexion.",
  "invitationsAria": "Invitations en cours",
  "colInvited": "Invité",
  "colExpires": "Expire",
  "colWillReceive": "Recevra",
  "invitedBy": "par {{name}}",
  "withdraw": "Retirer",
  "withdrawAria": "Retirer l’invitation pour {{email}}",
  "notWithdrawn": "Non retirée",
  "withdrawError": "Impossible de retirer cette invitation.",
  "nobodyYet": "Personne pour l’instant",
  "nobodyYetTenant": "Personne n’a encore accès à ce locataire. Invitez quelqu’un : l’accès l’attendra à sa première connexion.",
  "nobodyYetPlatform": "Personne ne s’est encore connecté. Invitez quelqu’un avec l’adresse qu’il utilisera : son rôle s’applique dès son arrivée.",
  "peopleAria": "Personnes",
  "colPerson": "Personne",
  "colLastSignIn": "Dernière connexion",
  "colAccess": "Accès",
  "notRevoked": "Non révoqué",
  "revokeError": "Impossible de révoquer cela.",
  "noAccessYet": "Pas encore d’accès",
  "revoke": "Révoquer",
  "revokeOwnerOnly": "Seul un propriétaire de plateforme peut révoquer la propriété",
  "revokeAria": "Révoquer {{role}}{{tenant}}",
  "onTenant": " sur {{name}}",
  "nobodyToGrant": "Personne à qui accorder l’accès pour l’instant — cette liste est celle des personnes déjà connectées. Invitez-les plutôt : le rôle s’applique à leur arrivée.",
  "personPlaceholder": "Choisissez quelqu’un qui s’est connecté",
  "role": "Rôle",
  "rolePlaceholder": "Choisissez un rôle",
  "tenant": "Locataire",
  "tenantPlaceholder": "Choisissez un locataire",
  "grant": "Accorder",
  "accessGranted": "Accès accordé.",
  "notGranted": "Non accordé",
  "grantError": "Impossible d’accorder cela.",
  "inviteTitle": "Inviter quelqu’un",
  "inviteHint": "Ils n’ont pas besoin de compte ici. La connexion suffit — le rôle ci‑dessous s’applique à leur première arrivée.",
  "workEmail": "E-mail professionnel",
  "workEmailDesc": "L’adresse avec laquelle ils se connecteront.",
  "differentOrg": "Ils se connectent depuis une autre organisation",
  "differentOrgDesc": "Cochez pour l’administrateur d’un client. Laissez décoché pour un collègue.",
  "theirDirectory": "Leur annuaire",
  "theirDirectoryPlaceholder": "ID locataire Entra, ou domaine Google Workspace",
  "theirDirectoryDesc": "Demandé car une adresse e-mail seule ne prouve rien — n’importe qui peut créer cette adresse dans un annuaire qu’il contrôle. L’invitation ne fonctionne que depuis l’annuaire nommé ici.",
  "sendInvitation": "Envoyer l’invitation",
  "invitedEmailed": "Invitation envoyée à {{email}}. Un e-mail a été envoyé.",
  "invitedNoEmailTitle": "Invitation pour {{email}}",
  "invitedNoEmailBody": "Aucun e-mail n’a été envoyé — ce déploiement n’a pas de messagerie sortante. Dites-leur de se connecter : leur accès les attendra.",
  "notInvited": "Non invité",
  "inviteError": "Impossible d’inviter cette personne.",
  "rolePlatformOwner": "Propriétaire de plateforme",
  "rolePlatformAdmin": "Administrateur de plateforme",
  "rolePartnerAdmin": "Administrateur partenaire",
  "roleTenantAdmin": "Administrateur de locataire",
  "roleEditor": "Éditeur",
  "roleDesigner": "Concepteur",
  "roleViewer": "Lecteur",
  "roleDescOwner": "Tout, y compris accorder la propriété à d’autres.",
  "roleDescAdmin": "Administre tous les locataires. Ne peut pas accorder de rôles plateforme.",
  "roleDescPartnerAdmin": "Administre chaque client de ce portefeuille partenaire, et qui d’autre peut le gérer.",
  "roleDescTenantAdmin": "Contrôle total d’un locataire, y compris sa liste d’accès.",
  "roleDescEditor": "Modifie les modèles, règles et campagnes.",
  "roleDescDesigner": "Modifie uniquement les modèles.",
  "roleDescViewer": "Lecture seule."
}
